import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { VoucherRepository } from '../../domain/repository/voucher.repository';
import { VoucherBcpCreateRequest, VoucherRegisterPayload } from '../../domain/models/voucher.model';

@Injectable()
export class HttpVoucherRepository implements VoucherRepository {
  private readonly typeEnvironmentApim = environment.Apim;

  constructor(private readonly http: HttpClient) { }

  register(payload: VoucherRegisterPayload): Observable<void> {
    const data: VoucherBcpCreateRequest = {
      nombre: payload.name,
      montoTransferido: payload.transferredAmount,
      desde: payload.accountTypeOrigin,
      fechaHora: payload.dateTime,
      enviadoA: payload.sentTo,
      ultimos4DigitosCuentaDestino: payload.destinationAccountLast4,
      ultimos4DigitosCuentaEnvio: payload.shippingAccountLast4,
      tipoCuentaEnvio: payload.accountType,
      operacionRealizada: payload.operation,
      recordIdConstitucion: payload.constitutionRecordId,
      mensaje: payload.message,
      canal: payload.channel,
      numeroOperacion: payload.operationNumber,
    };

    return this.http.post<void>(
      `${this.typeEnvironmentApim.migration_host}/` +
      `${this.typeEnvironmentApim.migration_paths.api}/` +
      `${this.typeEnvironmentApim.migration_paths.document}/` +
      `${this.typeEnvironmentApim.migration_paths.documentVoucherBcpCreate}`,
      data
    ).pipe(map(() => undefined));
  }
}
